"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InSitu = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Box_1 = require("@nerdwallet/currency/components/Box");
var Text_1 = require("@nerdwallet/currency/components/Text");
var ChevronRight_1 = __importDefault(require("@nerdwallet/react-icon/material/ChevronRight"));
var nerdwallet_plus_logo_1 = require("../../components/nerdwallet-plus-logo");
var variables_1 = require("../../styles/variables");
var in_situ_module_css_1 = __importDefault(require("./in-situ.module.css"));
var PointsText = function (_a) {
    var points = _a.points;
    return (react_1.default.createElement("div", { className: in_situ_module_css_1.default.textContainer },
        react_1.default.createElement(Text_1.Text, { component: "span", tone: "positive", bold: true },
            points,
            " "),
        react_1.default.createElement(Text_1.Text, { component: "span", tone: "positive", size: "x-small", bold: true },
            "\u00A0",
            "PTS")));
};
var InSitu = function (_a) {
    var _b;
    var atEdge = _a.atEdge, hideChevron = _a.hideChevron, onClick = _a.onClick, points = _a.points, showNerdwalletText = _a.showNerdwalletText;
    var Component = onClick ? "button" : "div";
    var showPoints = !!points;
    var showChevron = !points && !hideChevron;
    return (react_1.default.createElement(Component, { onClick: onClick, className: (0, classnames_1.default)(in_situ_module_css_1.default.container, (_b = {},
            _b[in_situ_module_css_1.default.containerTouchable] = !!onClick,
            _b[in_situ_module_css_1.default.containerSmall] = !points,
            _b[in_situ_module_css_1.default.containerEdge] = atEdge,
            _b)) },
        react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { logoColor: "green-dark", small: true, width: 24, height: 24 }),
        showNerdwalletText && (react_1.default.createElement(Box_1.Box, { className: in_situ_module_css_1.default.textContainer, marginRight: showChevron || showPoints ? 3 : 0 },
            react_1.default.createElement(Text_1.Text, { tone: "positive", bold: true, size: "small" }, "NERDWALLET+"))),
        showPoints && react_1.default.createElement(PointsText, { points: points }),
        showChevron && (react_1.default.createElement(ChevronRight_1.default, { size: "medium", color: variables_1.colors["green"], className: (0, classnames_1.default)(in_situ_module_css_1.default.chevron) }))));
};
exports.InSitu = InSitu;
